<template>
  <div>
    <div class="input-address mx-auto">
      <div class="row d-flex mobile-justify">
        <div class="col-sm-8 pr-0">
        <vue-google-autocomplete 
          ref="address"
          id="map" 
          classname="form-control" 
          placeholder="Enter your address"
          v-on:inputChange="inputChange"
          types="(regions)" 
          enable-geolocation="true"
          v-on:placechanged="getAddressData">
          </vue-google-autocomplete> 
        </div>
        <div class="col-sm-4 pl-0">
          <div class="input-group-append">
            <button @click="doSearch()" type="button" class="vh-btn primary search-btn">Find A Dealer</button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 error" v-if="error.status">
          {{ error.msg }}
        </div>
      </div>
    </div>

    <div class="map-wrap d-flex row" :class="{ noinited: !isinit }" >
      <div class="col-sm-4 p-0 locations-col" >
        <div class="d-flex h-100">
          <div class="locations rel">
            <div class="filteroptions" v-show="showFilters">

              <div class="checkbox">
                <label >
                  <input @change="applyFilter($event)" type="checkbox"  v-model="filterlist.guardian" />
                  <img src="https://vhb-transfer.s3.us-west-2.amazonaws.com/sw/layout/icon-ag.png" alt="American Guardians Dealer"/> <span class="dealer-option">American Guardians Dealer</span>
                </label>
              </div>

              <div class="checkbox">
                <label >
                  <input @change="applyFilter($event)" type="checkbox"  v-model="filterlist.ambassador" />
                  <img src="https://vhb-transfer.s3.us-west-2.amazonaws.com/sw/layout/icon-ambassador.png" alt="Ambassador Dealer"/> <span class="dealer-option">Ambassador Dealer</span>
                </label>
              </div>

              <div class="checkbox">
                <label >
                  <input @change="applyFilter($event)" type="checkbox"  v-model="filterlist.gunsmith" />
                  <img src="https://vhb-transfer.s3.us-west-2.amazonaws.com/sw/layout/icon-gunsmith.png" alt="GunSmith"/> <span class="dealer-option">GunSmith On Site</span>
                </label>
              </div>

              <div class="checkbox">
                <label >
                  <input @change="applyFilter($event)" type="checkbox"  v-model="filterlist.range" />
                  <img src="https://vhb-transfer.s3.us-west-2.amazonaws.com/sw/layout/icon-range.png" alt="Range"/> <span class="dealer-option">Range On Site</span>
                </label>
              </div>

            </div>
            <!-- <div  class="filters-toolbar d-flex justify-content-between p-1">
              <div class="cursor" @click="showFilters = !showFilters">Filters <span>{{ filtersCount() }}</span></div>              
              <div class="cursor" @click="clearFIlters()">Clear Filters X</div>
            </div> -->

            <div v-if="dealers && dealers.length > 0" class="location-results" @click="showFilters = false">
              <div 
                :key="index"
                v-for="(d, index) in dealers"
                
                class="dealer-location d-flex " @click="openWindow(index,'click')" @mouseover="openWindow(index)">
                  <div class="index d-flex align-items-center"><div>{{ index + 1 }}</div></div>
                  <div class="content">
                    <div class="d-flex justify-content-between">
                      <div class="">
                        <div class="title mb-1">{{ d.title }}</div>
                      </div>
                      <div class="distance">
                          {{ roundIt(d.distance,0) }} Mi.
                      </div>
                    </div>
                    <div class="addr" style="text-transform: capitalize;" v-html="fillInAddress(d,true)"></div>
                    <div>{{ d.tel }}</div>
                    <div class="hr"></div>
                    <div v-show="d.guardian == '1'"><img src="https://vhb-transfer.s3.us-west-2.amazonaws.com/sw/layout/icon-ag.png" alt="American Guardians Dealer"/> <span class="dealer-option">American Guardians</span></div>
                    <div v-show="d.ambassador == '1'"><img src="https://vhb-transfer.s3.us-west-2.amazonaws.com/sw/layout/icon-ambassador.png" alt="Ambassador Dealer" /> <span class="dealer-option">Ambassador Dealer</span></div>
                    <div v-show="d.gunsmith == 'Yes'"><img src="https://vhb-transfer.s3.us-west-2.amazonaws.com/sw/layout/icon-gunsmith.png" alt="GunSmith"/> <span class="dealer-option">GunSmith On Site</span></div>
                    <div v-show="d.range == 'Yes'"><img src="https://vhb-transfer.s3.us-west-2.amazonaws.com/sw/layout/icon-range.png" alt="Range"/> <span class="dealer-option">Range On Site</span></div>
                  </div>
                  <div @click="openWindow(index)" class="select d-flex align-items-center"></div>
                </div>
                <div class="text-center mt-2"><button class="vh-btn primary search-btn" v-if="page >= 0" v-on:click="pageIncrease()">Load More</button></div>
            </div>            
          </div>
        </div>
      </div>
      <div class="col-sm-8 p-0 map-col">
        <div class="map" @click="showFilters = false">
          <GoogleMap  style="width: 100%; height: 500px" :center="center" :zoom="15" ref="map">
            
              <Marker :options="origin"></Marker>

              <Marker 
                :key="index"
                ref="mker"
                v-for="(m, index) in dealers"
                @click="markerOpen($event)"
                :options="m" >
                  <InfoWindow ref="mkerinfo">
                    <div class="info-window" id="contet">
                      <div class="index">{{ m.label.text }}</div>
                      <div class="title mt-2">{{ m.title }}</div>
                      <span v-show="m.address"><a target="_blank" :href="'https://www.google.com/maps/place/' + (fillInAddress(m) ) +'/' + m.lat +',' + m.lng"><div class="address mb-1" style="text-transform: capitalize;" v-html="fillInAddress(m,true)"></div></a></span>
                      <span v-show="m.tel"><a target="_blank" :href="'tel:' + m.tel"><span class="tel-letter">P</span> {{ m.tel }}</a></span>
                      <div class="hr"></div>
                      <div v-show="m.guardian == '1'"><img src="https://vhb-transfer.s3.us-west-2.amazonaws.com/sw/layout/icon-ag.png" alt="American Guardians Dealer"/> <span class="dealer-option">American Guardians Dealer</span></div>
                      <div v-show="m.ambassador == '1'"><img src="https://vhb-transfer.s3.us-west-2.amazonaws.com/sw/layout/icon-ambassador.png" alt="Ambassador Dealer" /> <span class="dealer-option">Ambassador Dealer</span></div>
                      <div v-show="m.gunsmith == 'Yes'"><img src="https://vhb-transfer.s3.us-west-2.amazonaws.com/sw/layout/icon-gunsmith.png" alt="GunSmith"/> <span class="dealer-option">GunSmith On Site</span></div>
                      <div v-show="m.range == 'Yes'"><img src="https://vhb-transfer.s3.us-west-2.amazonaws.com/sw/layout/icon-range.png" alt="Range"/> <span class="dealer-option">Range On Site</span></div>
                    </div>
                    <br>
                    <div class="gm-actions">
                      <span v-show="m.address"><a target="_blank" :href="'https://www.google.com/maps/place/' +  fillInAddress(m ) +'/' + m.lat +',' + m.lng"><img src="https://vhb-transfer.s3.us-west-2.amazonaws.com/sw/layout/map-nav.png" alt="Navigate"/></a></span>
                      <span v-show="m.tel"><a target="_blank" :href="'tel:' + m.tel"><img src="https://vhb-transfer.s3.us-west-2.amazonaws.com/sw/layout/map-tel.png" alt="telephone" /></a></span>
                      <span v-show="m.mail"><a target="_blank" :href="'mailto:'+ m.mail"><img src="https://vhb-transfer.s3.us-west-2.amazonaws.com/sw/layout/map-mail.png" alt="email"/></a></span>
                      <span v-show="m.website"><a target="_blank" :href="m.website"><img src="https://vhb-transfer.s3.us-west-2.amazonaws.com/sw/layout/map-web.png" alt="web"/></a></span>
                    </div>
                  </InfoWindow>
              </Marker>
            
          </GoogleMap>        
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import VueGoogleAutocomplete from "vue-google-autocomplete";
import { GoogleMap, Marker, InfoWindow } from "vue3-google-map";
//import VueAxios from 'vue-axios'
import axios from 'axios'
//Vue.use(VueAxios, { $http: axios });

export default {
  name: 'HelloWorld',
  components: {
    VueGoogleAutocomplete,
    GoogleMap, 
    InfoWindow,
    Marker
  },
  data: function(){
    return {
      address:"",
      placeResult: null,
      prevAddress: "",
      origin: null,
      icon: "https://vhb-transfer.s3.us-west-2.amazonaws.com/tmp/sw-marker.png",
      gmap: null,
      map: null,
      isinit: false,
      showFilters: false,
      error:{
        status: false,
        msg: ""
      },
      filterlist:{
        guardian: false,
        ambassador: false,
        gunsmith: false,
        range: false,
      },
      temp2: null,
      //{"nid":"8875","title":" Trident Armory","field_lng_value":"44.7935715","field_lat_value":"-68.8547191","field_address_value":"3 Memory Lane","field_postal_code_value":"044001","field_city_value":"Hermon","field_range_value":"No","field_gun_smith_value":"Yes","distance":"3777.72130182845"}
      tmp: [
        
      ],
      dealers: [],
      center: {lat: 51.093048, lng: 6.842120},
      markers: [],    
      //autocompleteService: null
    }
  },
  mounted() {
    // //console.log(this.$refs.map)
    // console.log(this.$refs)
    console.log('Dealer Locator 1.0.6');
    
    //console.log(this.$refs.address, this)
    //this.$refs.address.placechanged
    var self = this;

    // setTimeout(function(){
    //   self.autocompleteService = new window.google.maps.places.AutocompleteService();
    //   // const service = self.gmaps.places.AutocompleteService();
    //   // service.getQueryPredictions({ input: "90039" }, function(p){
    //   // console.log('wow',p);
    // //});
    // },400)
    
    

    // To demonstrate functionality of exposed component functions
    // Here we make focus on the user input

    //this.$refs.address.autocomplete.addListener("place_changed", self.fillInAddress.bind(this))

    let urlParams = new URLSearchParams(window.location.search);
    if(urlParams.has('location') && urlParams.get('location') !== '' && urlParams.get('location') !== null){
      let location = urlParams.get('location');
      this.$refs.address.autocompleteText = location;
      var searchinput = document.getElementById("map");
      setTimeout(function(){ 
        self.triggerFocus(searchinput); 
        setTimeout(function(){ 
          //var item = document.querySelector('.pac-container .pac-item:first');
          window.jQuery('#map').val( window.jQuery('.pac-container .pac-item:first').text() );
          window.jQuery('.pac-container .pac-item:first').addClass('pac-item-selected');
          window.jQuery('.pac-container .pac-item:first').trigger('click');  
          window.jQuery('.pac-container .pac-item:first').trigger("keydown", {which: 13});
        },2000);
        
      },3000);
    }
    // if (window.navigator.geolocation) {
    //   console.log('nav');
    //       window.navigator.geolocation.getCurrentPosition(function (position) {
    //           let pos = {
    //               lat: position.coords.latitude,
    //               lng: position.coords.longitude
    //           };
    //           console.log(pos)

    //       });
    //   }

    this.gmaps = window.google.maps;
    this.$refs.address.focus();
    //axios.get('https://vhb-transfer.s3.us-west-2.amazonaws.com/tmp/stores.json').then((response) => {
    
    
  },
  filters: {
    strippedContent: function(string) {
           return string.replace(/<\/?[^>]+>/ig, " "); 
    }
  },
  methods: {
    pageIncrease: function(){
      this.page = this.page +1;
      this.getAddressData(this.address,this.placeResult,this.page )
    },
    applyFilter: function(){
      //console.log(this.filterlist);
      this.updateMap();
    },
    doSearch: function(){
      if(this.address == "" || this.$refs.address.autocompleteText == "")  return this.error = {
        status: true,
        msg: "Please enter a City and select a location"
      }

      
      if(this.prevAddress !== this.$refs.address.autocompleteText ){
        this.prevAddress, this.$refs.address.update(this.$refs.address.autocompleteText);
        //console.log(this.$refs.address)
        var searchinput = document.getElementById("map");
        this.triggerFocus(searchinput);        
        //console.log(searchinput)
      }

      

      
      //if(this.$refs.address.autocompleteText == "")
      
    },
    fillInAddress(location, display=false){
      let br = (display) ? "<br>" : '';
      return `${location.address} ${br}${location.city}, ${location.state} ${location.zip}`;
      //console.log(this,i)
    },
    inputChange: function(){
      
    },
    openWindow: function(index,action){    
      let idx = index;
      let marker = this.$refs.mker[idx].marker;
      let info = this.$refs.mkerinfo[idx];
      let map = this.$refs.map.map

      this.$refs.mkerinfo.forEach( info => info.infoWindow.close());

      ////console.log(map);
      
      info.infoWindow.open({
        anchor: marker,
        map: map
      })

      if(action == 'click'){
        var el = document.getElementById('dealerapp');
        var rect = el.getBoundingClientRect();
        window.scrollTo(rect.x, rect.y)
      }
    
    },
    markerOpen: function(){
      ////console.log(el._self.this.$refs);
    },
    triggerFocus: function(element) {
        var eventType = "onfocusin" in element ? "focusin" : "focus",
            bubbles = "onfocusin" in element,
            event;

        if ("createEvent" in document) {
            event = document.createEvent("Event");
            event.initEvent(eventType, bubbles, true);
        }
        else if ("Event" in window) {
            event = new Event(eventType, { bubbles: bubbles, cancelable: true });
        }

        element.focus();
        element.dispatchEvent(event);
    },
    filtersCount: function(){
      var i = 0;
      if(this.filterlist.guardian) i++;
      if(this.filterlist.ambassador) i++;
      if(this.filterlist.gunsmith) i++;
      if(this.filterlist.range) i++;
      return ( i>0 ) ? i : null;
    },
    getDistance: function (origin, dealer) {
      if(!dealer || !dealer.lat || !dealer.lng) return null;
      var R = 3956; // km
      var dLat = this.toRad(dealer.lat-origin.lat);
      var dLon = this.toRad(dealer.lng-origin.lng);
      var lat1 = this.toRad(origin.lat);
      var lat2 = this.toRad(dealer.lat);

      var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
        Math.sin(dLon/2) * Math.sin(dLon/2) * Math.cos(lat1) * Math.cos(lat2); 
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
      var d = R * c;
      if(!d) return null;
      var miles = this.round(d,2);
      if(!miles) return null
      return miles;
    },

    // Converts numeric degrees to radians
    toRad: function (Value) {
        return Value * Math.PI / 180;
    },
    round: function(n, dp) {
      const h = +('1'.padEnd(dp + 1, '0')) // 10 or 100 or 1000 or etc
      return Math.round(n * h) / h
    },
    clearFIlters: function(){      
        this.filterlist.guardian = false;
        this.filterlist.ambassador = false;
        this.filterlist.gunsmith = false;
        this.filterlist.range = false;
        this.showFilters = false;
        this.updateMap();
    },
    roundIt: function(num, decimalPlaces) {
      num = Math.round(num + "e" + decimalPlaces);
      return Number(num + "e" + -decimalPlaces);
    },
    updateMap: function(){
      var _self = this;
      if(this.$refs.mkerinfo) this.$refs.mkerinfo.forEach( info => info.infoWindow.close());
      var bounds = new _self.gmaps.LatLngBounds();
      this.dealers = [];
      
      this.dealers = this.tmp2;
      //console.log(this.dealers)
      


      // TEMPORARY
      // WE WILL REPLACE THIS IS BACKEND FUNCTINLAITY

      //GET DISTANCE
      // this.dealers.forEach( (d) => {
      //   d.distance = _self.getDistance(this.origin, d);
      // });

      //check if any filters exist
       let hasFilter = Object.values(this.filterlist).some( x => x === true );
       //console.log('hasfiler',hasFilter)

      if( hasFilter ){
        this.dealers = this.dealers.filter( dealer =>{
          if(!dealer.distance) return false;
          return Object.keys(_self.filterlist).some( f =>{
            if(_self.filterlist[f]) return dealer[f];
          })
          
        })
      }


      //SECODN CHECK
      this.dealers = this.dealers.filter( dealer => dealer.distance);

      //SORT BY DISTANCE
      //this.dealers.sort( (a,b) => parseInt(a.distance )< parseInt(b.distance) ? -1 : 1);

        //reduce results to revlant amount
       //this.dealers = this.dealers.slice(0, 10);

      //LIMIT BY 10;
      //END TEMPORARY

      let oloc = new _self.gmaps.LatLng(this.origin.position.lat, this.origin.position.lng);
      //console.log('map at',this.origin.position.lat, this.origin.position.lng)
      bounds.extend(oloc);

      // filter out no distance
      
      this.markers = this.dealers.forEach( (d,i) => {
        if(d.distance){
          d.label = {text: (i+1).toString(), color: "white"};
          d.icon = this.icon;
          d.position = {lat: parseFloat(d.lat), lng: parseFloat(d.lng) };
          // d.position.lat = d.lat;
          // d.position.lng = d.lng;
          let loc = new _self.gmaps.LatLng(parseFloat(d.lat), parseFloat(d.lng));
          bounds.extend(loc);
          //console.log('bound, lat',d.lat, d.lng, d.nid)
        }else{          
          console.log(`Error with ${d.title}`);
          //sad
        }
      });

      _self.$refs.map.map.fitBounds(bounds);
      _self.$refs.map.map.fitBounds(bounds);
      //console.log(_self.$refs.map.map)
      ////console.log(_self.$refs)
      // _self.$refs.map.$mapPromise.then((map) => {
      //   map.fitBounds(bounds);
      //   map.panToBounds(bounds)
      // });
      //_self.$refs.map.fitBounds(bounds);
      //_self.$refs.map.panToBounds(bounds)

      ////console.log(this.markers,this.dealers)
      // this.center = {
      //   lat: placeResultData.geometry.location.lat(), 
      //   lng: placeResultData.geometry.location.lng()
      // };
    },
    /**
     * When the location found
     * @param {Object} addressData Data of the found locationl
     * @param {Object} placeResultData PlaceResult object
     * @param {String} id Input container ID
     */
    getAddressData: function (addressData, placeResultData, page=null) {
      this.isinit = true;
      this.origin = {position: {lat: placeResultData.geometry.location.lat(), lng: placeResultData.geometry.location.lng()} };            
      this.address = addressData;
      this.placeResult = placeResultData;

      if(!page || page == 'map'){
        this.page = null; 
        
      }
      //console.log(page,this.page);
      ////console.log(addressData, placeResultData.formatted_address)
      this.prevAddress = placeResultData.formatted_address
      ////console.log('getting locations', this.origin.position);
      
      //let urllive = 'https://sw-portal.local';
      let urllive = 'https://dealerresources.smith-wesson.com';
      let pagination = (this.page > 0) 
        ? `&page=${this.page}`
        : '' ;

        //console.log(this.page,pagination)

      axios.get(`${urllive}/api/dealers?lng=${placeResultData.geometry.location.lng()}&lat=${placeResultData.geometry.location.lat()}${pagination}`).then((response) => {
        if(this.page > 0){
          this.tmp2 = [...this.tmp2, ...response.data.dealers]
        }else{
          this.tmp2 = response.data.dealers;
          var scrollercontent = document.getElementsByClassName('location-results');
          if(scrollercontent && scrollercontent[0] !== undefined) scrollercontent[0].scrollTo({top:0})
        }
        this.updateMap();
        if(this.page == null) this.page=0;
        //console.log("dealers",this.tmp2, this.page)
      })
      
    },
  },
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @media (min-width: 768px){
    .col-sm-8 {
        float: left;
        width: 66.66666667%;
        position: relative;
        min-height: 1px;
    }
    
    .col-sm-4 {
        width: 33.33333333%;
        float: left;
        position: relative;
        min-height: 1px;
    }
  }
  
  .locations-col,
  .map-col{
    padding-left:0!important;
    padding-right:0!important;
  }
  .sw-vh .h-100 {
        height: 100%;
    }
    .rel {
        position: relative;
    }
  #dealerapp{
    font-family: "Open Sans",Arial,sans-serif;
    font-size: 14px;
    line-height: 1.42857143;
    color: #444;
  }
  
  .form-control{
    line-height: 1.42857143;
    color: #444;
    animation-name: endBrowserAutofill;
    -webkit-appearance: none;
    border: 1px solid #ccc;
    padding: 10px 5px;
    font-size: 16px;
    height: auto;
    display: block;
        background-color: #fff;
        border-radius: 0;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.8);
    width: 100%;
  }
  .align-items-center {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  .d-flex {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
  }
  .input-address{
    width: 100%;
    max-width: 600px;
    margin-bottom: 20px;
  }
  .hr{
    margin-top: 10px;
    margin-bottom: 10px;
    height: 1px;
    background: #dedede;
    border-bottom: none!important;
  }
  .location-results{
      position: absolute;
      overflow: auto;
      height: calc( 100% - 30px );
      //top: 30px;
      top: 0;
      width: 100%;
      margin-bottom: -30px;
      @media(max-width: 1030px){
        position: relative;
      }
  }
  .error{
      margin-top: 5px;
      padding: 5px;
  }
  .mobile-justify{
    @media(max-width: 767px){
      justify-content: center!important;
    }
  }
  .distance{
    font-size: 12px;
    color:#1354a1;
    min-width: 40px;
    margin-left: 5px;
    text-align: right;
  }
  .locations-col,
  .map-col{
    transition: 0.3s;
    @media(max-width: 1030px){
      width: 100%!important;
    }
  }
  .noinited{
    .locations-col{
      width:0;
      overflow: hidden;
    }
    .map-col{
      width: 100%;
    }
  }
  .addr{
    font-size: 12px;
  }
  .mx-auto{
    margin-left: auto;
    margin-right: auto;
  }
  .pl-0{ padding-left:0!important;}
  .pr-0{ padding-right:0!important;}
  .search-btn{  }
  .map-wrap{ 
    @media(max-width: 1030px){ flex-direction: column-reverse; }
    border: 3px solid #444; margin-bottom: 20px; margin:0;
    }
  .locations{ 
    border-right: 3px solid #444; 
    
    flex-grow: 1; 
    margin-top: -1px;
    margin-bottom: -1px;
    margin-left: -1px;
  }
  .filters-toolbar{
    display: none;
    background-color: #333333;
    color: #fff;
  }
  .dealer-location{
    border-bottom: 2px solid #acaeb0;
    align-items: stretch!important;
    .index{
      background: #eee;
      color: #1354a1;
      padding-left: 10px;
      padding-right: 10px;
      font-size: 24px;
      font-weight: 800;
    }
    .content{
      flex-grow: 1;
      padding: 10px;
    }
    .title{
      font-weight: 800;
      text-transform: uppercase;
    }
    .select{
      color: #1354a1;
      font-size: 24px;
      font-weight: 800;
      padding: 10px;
      &:before{
        display: inline-block;
        font: normal normal normal 14px/1 FontAwesome;
        font-size: inherit;
        text-rendering: auto;
        -webkit-font-smoothing: antialiased;
        content: "\f105";
        font-size: 150%;
        font-weight: 800;
      }
    }

    &:hover{
      border-bottom-color: #1354a1;
      transition: 0.3s;
      .index,
      .select{
        transition: 0.3s;
        background-color: #1354a1;
        color: #fff; 
      }
    }
  }
  
  .info-window{
    //border-radius: 5px;
    position: relative;
    min-height: 100px;
    .title{
      text-transform: uppercase;
      font-weight: 800;
      font-size: 18px;
    }
    .index{
      background: #1354a1;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      color: #fff;
      position: absolute;
      transform: translateX(-50%) translateY(-50%);
      left: 50%;
      font-size: 20px;
      font-weight: 800;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      top: -30px;
    }
  }
  .filteroptions{
    position: absolute;
    top: 30px;
    width: 100%;
    padding: 10px;
    background: #fff;
    border-bottom: 2px solid #333; 
    z-index: 5;
  }
  .cursor{
    cursor: pointer;
  }
  .dealer-option{
    text-transform: uppercase;
    font-weight: 800;
    font-size: 11px;
  }
  .h-100{
    height: 100%;
  }
  .vh-btn.primary{
    border: 1px solid transparent;
    background: #1354a1;
    color: #fff;
    padding: 13.5px 25px;
    text-decoration: none;
    text-transform: uppercase;
    font-weight: 700;
    display: inline-block;
    text-align: center;
    transition: 0.3s;
    cursor: pointer;
  }
</style>

<style >
  .justify-content-between{
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
  }
  .gm-actions{
    background: #1354a1;
    text-align: center;
    margin-left: -16px; 
    padding: 1px;
    margin-right: -17px;
    margin-bottom: -1px;
  }
  .gm-style-iw.gm-style-iw-c{ 
    padding-top:0!important;
    padding-left:0!important;
    overflow: visible!important; }
  .gm-style-iw-d{
    overflow: visible!important;
    padding: 15px 15px 0 15px;
    border: 2px solid #1354a1;
    border-radius: 5px;
  }
  .gm-style-iw .gm-style-iw-c,
  .gm-style .gm-style-iw-t{
    padding-top:0!important;
    padding-left:0!important;
  }
  .gm-style .gm-style-iw-t::after{
    background: #1354a1!important;
  }
  .tel-letter{
    color: #1354a1;
    font-weight: 800;
  }
  .sw-vh .mt-2 {
      margin-top: 15px;
  }

  .text-center {
      text-align: center;
  }
  #dealerapp{
    font-family: "Open Sans",Arial,sans-serif;
    font-size: 14px;
    line-height: 1.42857143;
    color: #444;
  }
</style>
